import AbstractTrigger from '@/ghost/service/Triggers/AbstractTrigger'
import { MethodDescriptor } from '@/common/model/PaymentMethod'

export default class DeclinePartialPaymentTrigger extends AbstractTrigger {
  constructor($locator) {
    super($locator, 'declinePartialPaymentCall')
    this.browserRequests = $locator.browserRequests
  }

  async onEvent({ transactionUuid }) {
    try {
      await super.onEvent({})
      this.paymentMethod = new MethodDescriptor(
        'PARTIAL_TRANSACTION',
        transactionUuid
      ).toString()

      const { response } = await this.callDeclinePartialPayment(transactionUuid)
      if (response.status === 'ERROR') {
        this.onError(response.answer)
      } else {
        this.proxy.send(
          this.storeFactory.create('declinePartialPaymentApply', {
            transactionUuid,
            answer: response.answer
          })
        )
      }
    } catch (error) {
      this.onError(error)
    }
  }

  async onError(
    error,
    path = 'ghost/service/DeclinePartialPaymentTrigger.onEvent'
  ) {
    this.$store.dispatch('closeModal')
    super.onError(error, path)
  }

  async callDeclinePartialPayment(transactionUuid) {
    const { formToken, publicKey } = this.$store.state
    let url = this.restAPI.getDeclinePartialPaymentUrl(this.endpoint)
    url = this.restAPI.addJSessionID(url)
    const requestData = this.storeFactory.create('requestData', {
      url,
      objectData: {
        formToken,
        publicKey,
        wsUser: this.restAPI.getWSUser(),
        transactionUuid
      },
      headers: {},
      options: {}
    })
    return await this.browserRequests.post(requestData)
  }
}
